import { useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Swal from 'sweetalert2'
import useCertificationsApi from '../../list/hooks/useCertificationsApi'

export default function useCertificationAddPage() {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const { createCertification } = useCertificationsApi()
	const [submitting, setSubmitting] = useState(false)

	const handleCancel = useCallback(() => {
		navigate('/centrumSzkolen/certyfikaty')
	}, [navigate])

	const handleSubmit = useCallback(async payload => {
		if (submitting) return

		setSubmitting(true)
		const result = await createCertification(payload)

		if (!result.success) {
			await Swal.fire(
				t('trainingCertifications.messages.errorTitle'),
				result.error || t('trainingCertifications.add.messages.createFailed'),
				'error'
			)
			setSubmitting(false)
			return
		}

		await Swal.fire(
			t('trainingCertifications.add.messages.createdTitle'),
			t('trainingCertifications.add.messages.createdSuccess'),
			'success'
		)

		setSubmitting(false)
		navigate('/centrumSzkolen/certyfikaty')
	}, [createCertification, navigate, submitting, t])

	return {
		handleCancel,
		handleSubmit,
		submitting,
	}
}
